// src/components/PrintButton.jsx
import React, { useState } from "react";
import { PrinterIcon } from "@heroicons/react/solid";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import moment from "moment";
import Spinner from "../loaders/Spinner";

const appendTimeStamp = (filename) =>
  filename + "_" + moment().format("YYYY-MM-DD_HH-mm");

export default function ReceiptPrintButton({
  targetId = "print-area",
  filename = "receipt",
  children,
}) {
  const [processing, setProcessing] = useState(false);

  const handlePrint = async () => {
    setProcessing(true);

    try {
      const element = document.getElementById(targetId);

      if (!element) {
        alert(`Print area not found (#${targetId})`);
        return;
      }

      // High DPI but safe
      const scale = 2;

      const canvas = await html2canvas(element, {
        scale,
        backgroundColor: "#ffffff",
        useCORS: true,
      });

      const imgData = canvas.toDataURL("image/png");

      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "px",
        format: [canvas.width, canvas.height],
      });

      pdf.addImage(
        imgData,
        "PNG",
        0,
        0,
        canvas.width,
        canvas.height
      );

      pdf.save(`${appendTimeStamp(filename)}.pdf`);
    } catch (err) {
      console.error("Print failed", err);
      alert("Failed to export receipt");
    } finally {
      setProcessing(false);
    }
  };

  return (
   <button
      onClick={handlePrint}
      disabled={processing}
      className="bg-primary hover:bg-primary text-white tracking-normal font-semibold text-xs py-2 px-4 rounded-md inline-flex items-center min-w-[80px] mx-auto justify-center"
    >
      {!processing ? (
        <>
          <PrinterIcon width={16} height={16} fill="#ffffff" />
          <span className="uppercase ml-2 hidden lg:block">
            {children ?? "Print"}
          </span>
        </>
      ) : (
        <Spinner width={16} height={16} />
      )}
    </button>
  );
}
